import RadioButton from '../radio/src/radio-button.vue';

RadioButton.install = function(Vue) {
  Vue.component(RadioButton.name, RadioButton);
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/radio-button/index.js